import { apiPost, apiGet, tokenStorage } from './api';
import type { AuthTokenResponse, LoginInput, RegisterInput, User } from '../types/auth.types';

export const authService = {
  async register(input: RegisterInput): Promise<AuthTokenResponse> {
    const data = await apiPost<AuthTokenResponse, RegisterInput>('/auth/register', input);
    tokenStorage.set(data.token);
    return data;
  },

  async login(input: LoginInput): Promise<AuthTokenResponse> {
    const data = await apiPost<AuthTokenResponse, LoginInput>('/auth/login', input);
    tokenStorage.set(data.token);
    return data;
  },

  async getMe(): Promise<User> {
    const data = await apiGet<{ user: User }>('/auth/me');
    return data.user;
  },

  async logout(): Promise<void> {
    try {
      await apiPost('/auth/logout', {});
    } finally {
      // Always clear local token even if request fails
      tokenStorage.remove();
    }
  },
};
